{
  "dss": {
    "button": {
      "back": "Späť",
      "cancel": "Zrušiť",
      "close": "Zavrieť",
      "confirmDelete": "Áno, vymazať",
      "continue": "Pokračovať",
      "logout": "Odhlásiť sa",
      "passwordReset": "Obnovenie hesla",
      "save": "Uložiť",
      "verify": "Overiť"
    },
    "error": {
      "403": "K tejto stránke nemáte prístup.",
      "404": "Táto stránka neexistuje.",
      "generic": "Vyskytla sa chyba. Skúste to prosím neskôr.",
      "throttling": "Príliš veľa pokusov. Táto operácia je dočasne zablokovaná.",
      "title": "Chyba",
      "title403": "Prístup zamietnutý",
      "title404": "Nenašlo sa"
    },
    "footer": {
      "imprint": "Impressum",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "Zásady ochrany osobných údajov",
      "terms": "Obchodné podmienky"
    },
    "label": {
      "CRMAccountNumber": "Číslo účtu CRM",
      "contact": "Kontakt",
      "email": "Email",
      "faq": "FAQ",
      "female": "Pani",
      "firstname": "Meno",
      "help": "Pomoc",
      "language": "Jazyk",
      "lastname": "Priezvisko",
      "male": "Pán",
      "needHelp": "Potrebujete pomoc?",
      "newPassword": "Nové heslo",
      "newPassword2": "Potvrďte nové heslo",
      "oldPassword": "Aktuálne heslo",
      "organization": "Organizácia",
      "password": "Heslo",
      "required": "povinné",
      "salutation": "Oslovenie",
      "select": "Prosím vyberte"
    },
    "lang": {
      "de": "Nemčina"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Potvrdiť registráciu",
        "wait": "Počkajte prosím, kým sa dokončí potvrdenie účtu."
      },
      "otp": {
        "btnResend": "Znova odoslať overovací kód",
        "msg": {
          "invalidOTP": "Zadané jednorazové heslo je neplatné.",
          "resendFail": "Nepodarilo sa znova odoslať kód. Skúste to prosím neskôr."
        },
        "spamDetail": "Skontrolujte doručenú poštu a priečinok so spamom pre e-mail od STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Nedostal(a)i ste e-mail?",
        "subtitle": "Ak chcete pokračovať, musíte overiť svoju e-mailovú adresu.",
        "title": "Overte svoj používateľský účet",
        "txtVerifyMail": "Zadajte prosím nový overovací kód, ktorý sme poslali na vašu e-mailovú adresu {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Nie je čo aktualizovať.",
          "updateError": "Nepodarilo sa aktualizovať osobné údaje.",
          "updated": "Osobné údaje boli aktualizované.",
          "userLoadErr": "Pri načítaní používateľských údajov došlo k chybe. Skúste to prosím neskôr."
        },
        "secOrganization": "Organizácia",
        "secPersonal": "Osobné",
        "secSettings": "Preferované nastavenia",
        "title": "Osobné informácie"
      },
      "postPwSet": {
        "info": "Teraz môžete používať svoje nové heslo.",
        "link_name": "Pokračovať do Self-Service",
        "link_url": "/user/ui/",
        "title": "Vaše heslo bolo zmenené"
      },
      "resetPW": {
        "title": "Obnovte svoje heslo"
      },
      "security": {
        "2fa": {
          "availableMethods": "Dostupné metódy 2FA:",
          "info": "Dvojfaktorová autentifikácia (2FA) je bezpečnostná funkcia, ktorá pridáva do vášho účtu ďalšiu vrstvu ochrany. Vyžaduje použitie dvoch metód prihlásenia namiesto samotného mena a hesla.",
          "method": {
            "email": "Email",
            "emailDesc": "Dostávajte jednorazové kódy e-mailom na dokončenie požiadaviek na autentifikáciu.",
            "oath": {
              "add": {
                "button": "Registrovať aplikáciu Authenticator"
              }
            }
          }
        },
        "authenticator": "Aplikácia Authenticator",
        "infoFederatedAccount": "Toto konto spravuje poskytovateľ identity vašej organizácie, takže heslo tu nemožno zmeniť. Ak chcete zmeniť heslo, prihláste sa cez prihlasovaciu stránku svojej organizácie alebo kontaktujte svojho IT administrátora.",
        "lastUse": "Naposledy použité: {0}.",
        "msg": {
          "invalidPassword": "Zadané aktuálne heslo je neplatné.",
          "passwordAlreadyUsed": "Nie je možné znovu použiť posledných 5 hesiel.",
          "pwUpdateError": "Pri pokuse o zmenu hesla došlo k chybe.",
          "pwUpdated": "Heslo bolo zmenené."
        },
        "noDevice": "Nenastavené",
        "oathAdd": {
          "appInfo": "Aby bol proces prihlásenia do STIHL jednoduchší, môžete používať aplikácie Authenticator ako {0}, {1}, {2} atď. na generovanie jednorazových hesiel, ktoré sa používajú ako druhý faktor počas prihlásenia.<br/>Ak ste stratili alebo zabudli svoje mobilné zariadenie, môžete kedykoľvek použiť 2FA kód zaslaný e-mailom.<br/><br/>Postupujte podľa pokynov nižšie a nastavte svoje autentifikačné zariadenie.",
          "badCode": "Neplatný kód, skúste to prosím znova.",
          "error": "Pri pokuse o registráciu autentifikačného zariadenia došlo k chybe.",
          "headScan": "1. Naskenujte QR kód svojou aplikáciou Authenticator",
          "headVerify": "2. Overte kód",
          "infoKey": "nastavovací kľúč",
          "infoKeyTitle": "Vaše dvojfaktorové tajomstvo",
          "infoScanBottom": "Nedarí sa skenovať? Môžete použiť {0} na manuálne nastavenie aplikácie Authenticator.",
          "infoVerify": "Zadajte kód vygenerovaný vašou aplikáciou Authenticator.",
          "success": "Vaše autentifikačné zariadenie bolo zaregistrované. Teraz ho môžete používať na prihlásenie.",
          "title": "Zaregistrujte svoje zariadenie pre dvojfaktorovú autentifikáciu"
        },
        "oathDelete": {
          "error": "Pri pokuse o odstránenie autentifikačného zariadenia došlo k chybe.",
          "success": "Autentifikačné zariadenie bolo odstránené."
        },
        "passkeys": {
          "about": {
            "info1": "Passkey sú páry kryptografických kľúčov (verejný a súkromný kľúč), ktoré ukladá autentifikátor pod vašou kontrolou. Autentifikátor môže preukázať, že používateľ je prítomný a je oprávnený používať passkey. Autentifikátory preukazujú oprávnenie pomocou PINu, kódu, biometrie alebo hesla zariadenia v závislosti od svojich možností a konfigurácie. Autentifikátory existujú v rôznych formách: iPhone alebo Android zariadenie, Windows Hello, hardvérový bezpečnostný kľúč FIDO2 alebo správca hesiel.",
            "info2": "Keď sa prihlasujete do STIHL pomocou passkey, váš autentifikátor používa kryptografiu s verejným kľúčom na preukázanie vašej identity pred STIHL bez toho, aby niekedy odoslal samotný passkey. Passkey sú viazané na doménu webovej stránky, ako je stihl-sso.com, a vyžadujú zabezpečené pripojenie, čo znamená, že prehliadač odmietne autentifikáciu na napodobnenej phishingovej stránke. Tieto vlastnosti robia passkey vysoko odolnými voči phishingu a oveľa ťažšie napadnuteľnými ako SMS alebo TOTP 2FA.",
            "info3": "Služby passkey založené na cloude umožňujú synchronizáciu kľúčov medzi zariadeniami (napr. zariadeniami Apple, Android alebo správcami hesiel), aby sa dali používať na viacerých miestach a menej sa strácali. Keď nastavíte synchronizovaný passkey na jednom zariadení, je dostupný na viacerých zariadeniach používajúcich rovnakú službu. Napríklad, ak zaregistrujete passkey vo svojom účte iCloud pomocou Touch ID na MacBooku, potom môžete tento passkey používať s rozpoznaním tváre, odtlačkom prsta, PINom alebo heslom zariadenia na viacerých zariadeniach prepojených s rovnakým účtom iCloud.",
            "title": "O Passkeys"
          },
          "add": {
            "button": "Pridať nový Passkey",
            "error": "Pri pokuse pridať nový passkey došlo k chybe.",
            "success": "Nový passkey bol pridaný."
          },
          "delete": {
            "button": "Odstrániť Passkey",
            "error": "Pri pokuse o odstránenie tohto passkey došlo k chybe.",
            "success": "Passkey bol odstránený."
          },
          "edit": {
            "error": "Pri pokuse o uloženie názvu passkey došlo k chybe.",
            "name": "Názov Passkey",
            "success": "Názov passkey bol aktualizovaný.",
            "title": "Pomenujte svoj Passkey, aby ste ho odlíšili od ostatných"
          },
          "info": "Passkey je jednoduchá a bezpečná alternatíva k heslám, ktorá overuje vašu identitu pomocou dotyku, rozpoznávania tváre, hesla zariadenia alebo PINu.",
          "none": "Nie je nakonfigurovaný žiadny Passkey.",
          "reallyDelete": "Naozaj chcete odstrániť Passkey?",
          "registeredPasskeys": "Vaše registrované Passkey:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "Naozaj chcete odstrániť autentifikačné zariadenie?",
        "secMFA": "Dvojfaktorová autentifikácia",
        "secPwdChange": "Zmeniť heslo",
        "title": "Zabezpečenie"
      },
      "setPW": {
        "acceptTC": "Potvrďte, prosím, naše {terms} a prečítajte si naše {privacy}.",
        "killSSO": "Zneplatniť všetky aktívne relácie",
        "msg": {
          "tokenExpired": "Platnosť odkazu alebo kódu pre heslo vypršala. Postupujte podľa odkazu na obnovenie hesla: {link}."
        },
        "privacy": "Zásady ochrany údajov",
        "terms": "Obchodné podmienky",
        "title": "Zadajte nové heslo"
      }
    },
    "validations": {
      "hasDigit": "Musí obsahovať číslicu(y)",
      "hasLowercase": "Musí obsahovať malé písmená",
      "hasSpecial": "Musí obsahovať špeciálne znaky: {chars}",
      "hasUppercase": "Musí obsahovať veľké písmená",
      "invalidCharacters": "Obsahuje neplatné znaky",
      "maxLength": "Maximálne {max} znakov",
      "minLength": "Minimálne {min} znakov",
      "notSameAsEmail": "Príliš podobné e-mailovej adrese",
      "onlyValidCharactersAllowed": "Sú povolené iba písmená, čísla a medzery.",
      "required": "Povinné pole",
      "sameAsPassword": "Heslá sa nezhodujú",
      "tcAccepted": "Potvrďte, prosím, naše obchodné podmienky.",
      "validEmail": "Neplatná e-mailová adresa.",
      "validOTP": "Zadajte, prosím, overovací kód."
    }
  }
}
